module.exports = __webpack_public_path__ + "static/Corprate_WhoWeAre_05-a07cd2442828d6f6ae5a2cd237294472.jpg";